<template>
  <div style="text-align:center;padding-top:100px;">
    <van-loading style="margin:auto;" color="#1989fa"  type="spinner" size="48" />
  </div>
</template>
<script>
import { getSearch } from '@/common/url.js'
import Vue from 'vue'
export default {
  mounted(){
    // console.log('this.$store.state.isWeiXin',this.$store.state.isWeiXin)
    const search = getSearch(window.location.href)
    if (search && search.code) {
      Vue.ss.set('ssCode', search.code)
      let url='#/'+Vue.ss.set('pageUrl')
      if(url){
        window.location.href=url
      }
    }else{
      // this.$store.dispatch("wxLogin/wxLogin");
    }
  }
}
</script>